import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "./localStorageHelpers";

const localStorageKey = "onboarding";

export const getOnboardingData = () => {
  let onboardingData = {};

  try {
    const onboardingStr = getLocalStorageItem(localStorageKey);
    onboardingData = onboardingStr ? JSON.parse(onboardingStr) : {};
  } catch (error) {
    console.log(error);
  }

  return onboardingData;
};

export const setOnboardingData = data => {
  try {
    const prevData = getOnboardingData();

    setLocalStorageItem(
      localStorageKey,
      JSON.stringify({
        ...prevData,
        ...data,
      })
    );
  } catch (error) {
    console.log(error);
  }
};
